var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMailGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_1617)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13498 4.64044L8.77202 11.1896C10.2196 12.6146 12.5858 12.6158 14.0346 11.1896L20.6716 4.64044C20.6873 4.62505 20.6994 4.60645 20.707 4.58594C20.7146 4.56544 20.7175 4.54354 20.7155 4.5218C20.7136 4.50006 20.7068 4.47901 20.6957 4.46014C20.6846 4.44127 20.6694 4.42504 20.6512 4.41261C19.9742 3.94696 19.1506 3.6709 18.2634 3.6709H4.54326C3.656 3.6709 2.83237 3.94701 2.15542 4.41261C2.13723 4.42504 2.12204 4.44127 2.11092 4.46014C2.09979 4.47901 2.09302 4.50006 2.09107 4.5218C2.08912 4.54354 2.09204 4.56544 2.09963 4.58594C2.10722 4.60645 2.11929 4.62505 2.13498 4.64044ZM0.361329 7.7956C0.360789 7.13017 0.524748 6.47464 0.839002 5.88581C0.849973 5.86505 0.865755 5.84714 0.885065 5.83352C0.904375 5.81991 0.926669 5.81099 0.950134 5.80747C0.973599 5.80396 0.997574 5.80596 1.02011 5.8133C1.04265 5.82065 1.06311 5.83313 1.07983 5.84974L7.63285 12.3132C9.70798 14.3629 13.0974 14.3641 15.1738 12.3132L21.7268 5.84974C21.7435 5.83313 21.764 5.82065 21.7865 5.8133C21.8091 5.80596 21.833 5.80396 21.8565 5.80747C21.88 5.81099 21.9023 5.81991 21.9216 5.83352C21.9409 5.84714 21.9567 5.86505 21.9676 5.88581C22.2819 6.47465 22.4458 7.13017 22.4453 7.7956V16.4062C22.4453 18.6823 20.5682 20.5309 18.2634 20.5309H4.54326C2.23853 20.5309 0.361329 18.6823 0.361329 16.4062V7.7956Z",
    fill: "#1BA929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_1617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4745,
    height: 22.4745,
    fill: "white",
    transform: "translate(0 0.827148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailGreen);
export default __webpack_public_path__ + "static/media/icon_mail_green.bd5a16d1dd65258de3555888c9e51374.svg";
export { ForwardRef as ReactComponent };